<template>
  <div class="chat-conversations-search">
    <input
      type="text"
      v-model="localValue"
      placeholder="Pesquisar..."
      class="chat-conversations-search-input"
    />
  </div>
</template>

<script>
export default {
  name: 'ChatConversationsSearch',
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['update:value'],
  model: {
    prop: 'value',
    event: 'update:value'
  },
  data () {
    return {
      internalValue: ''
    }
  },
  computed: {
    localValue: {
      get () {
        return this.internalValue
      },
      set (value) {
        this.internalValue = value
        this.$emit('update:value', value)
      }
    }
  },
  beforeMount () {
    this.internalValue = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/central_atendimento_geral/components/conversations/ConversationsSearch.vue